export default "__VITE_ASSET__12f1c992__"